import { render, staticRenderFns } from "./SaleDetail.vue?vue&type=template&id=36b60577&scoped=true"
import script from "./SaleDetail.vue?vue&type=script&lang=js"
export * from "./SaleDetail.vue?vue&type=script&lang=js"
import style0 from "./SaleDetail.vue?vue&type=style&index=0&id=36b60577&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b60577",
  null
  
)

export default component.exports